import Lottie from 'react-lottie';
import animationData from '../../../assets/animation/404.json';

const Error = () => {
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <section className="outer">
                <div className="middle">
                    <div className="inner">
                        <div className={'container h-100'}>
                            <div className={'row h-100 align-items-center justify-content-center'}>
                                <div className={'col-md-7 col-12'}>
                                    <Lottie
                                        options={defaultOptions}
                                        height={400}
                                    />
                                    <p className={'text-center text-white fw-bold animate-text'}>
                                        ایران تراکنشی عزیز ، صفحه مد نظر پیدا نشد...
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Error